module.exports = __webpack_public_path__ + "static/media/7@1920w.2ed73356.jpg";